import React from 'react';

import { useGlobalStoreActions } from '@client/store/globalStore/context/globalContext';
import { Login as LoginForm } from '@ledium/common-login';

const Login = () => {
    const { globalActions } = useGlobalStoreActions();

    function onSubmit(username: string, password: string) {
        globalActions.users.callUserLogin({ username, password });
    }

    return <LoginForm onSubmit={onSubmit} />;
};

export default React.memo(Login);
